import { getAriaLabelFromElements } from "./getAriaLabelFromElements.ts";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const getAriaLabelFromInteractiveElement = (customElement: HTMLElement): string | null => {
  /*                                                                     */
  if (!customElement.shadowRoot) return getAriaLabelFromElements(customElement);

  /*                                                                             */
  const slots: HTMLSlotElement[] = Array.from(
    customElement.shadowRoot.querySelectorAll(
      `slot[name]:not([name="hint"]):not([name="violation-message"])`,
    ),
  );

  /*                                                                          */
  const assignedElements = slots.flatMap((slot) => slot.assignedNodes());

  return getAriaLabelFromElements(...assignedElements);
};
